import { Routes } from '@angular/router';
import { LayoutComponent } from './app/layout/component/layout/layout.component';
import { Documentation } from './app/pages/documentation/documentation';
import { Landing } from './app/pages/landing/landing';
import { AuthGuard } from './app/core/guards/auth.guard';
import { NotfoundComponent } from './app/features/public/auth/components/notfound/notfound.component';
import { SharedDirectoryComponent } from './app/features/default/shared/shared-directory/shared-directory.component';

export const appRoutes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        canActivateChild: [AuthGuard],
        data: { roles: ['admin', 'user'] },
        children: [
            { path: '', component: SharedDirectoryComponent, data: { roles: ['admin', 'user'] } },//TODO: FAZER O DASHBOARD NO COMPONENTE JA EXISTENTE (DASHBOARD)
            { path: 'admin',loadChildren: () => import('./app/features/admin/admin.routes'), data: { roles: ['admin'] } },
            { path: 'default',loadChildren: () => import('./app/features/default/default.routes'), data: { roles: ['admin', 'user'] } },
            { path: 'uikit', loadChildren: () => import('./app/pages/uikit/uikit.routes'), data: { roles: ['admin', 'user'] } }, //sera removido
            { path: 'documentation', component: Documentation, data: { roles: ['admin', 'user'] }}, //sera removido
            { path: 'pages', loadChildren: () => import('./app/pages/pages.routes'), data: { roles: ['admin', 'user'] }} //sera removido
        ]
    },
    { path: 'landing', component: Landing },
    { path: 'notfound', component: NotfoundComponent },
    { path: 'authentication', loadChildren: () => import('./app/pages/auth/auth.routes') },
    { path: 'public', loadChildren: () => import('./app/features/public/public.routes') },
    { path: '**', redirectTo: '/notfound' }
];
